/**
 * Creates a share record and returns a share URL.
 */
import { collection, doc, serverTimestamp, setDoc } from "firebase/firestore"

import { db } from "../configs/firebase"

const useShareLink = ({
  origin = typeof window !== "undefined" ? window.location.origin : "",
} = {}) => {
  const createShare = async ({ userId, documentId, durationHours }) => {
    if (!documentId || !userId) {
      throw new Error("Missing documentId or userId for sharing")
    }

    const now = new Date()
    const expiresAt = new Date(now.getTime() + durationHours * 60 * 60 * 1000)

    const ref = doc(collection(db, "sharingDocuments"))
    const payload = {
      _createdBy: userId,
      _id: ref.id,
      _expiresAt: expiresAt,
      _createdAt: serverTimestamp(),
      documentId,
    }
    await setDoc(ref, payload)

    const shareUrl = `${origin}/share/${ref.id}`
    return shareUrl
  }

  return { createShare }
}

export default useShareLink
